import React, { useEffect, useState } from "react";
import Button from "../../../../component/button/Button";
import Input from "../../../../component/input/Input";
// import Select, { ValueContainerProps, components } from "react-select";
import { useLocation, useParams } from "react-router-dom";
import Select from "../../../../component/multiSelect/MultiSelect";
import SingleSelect from "../../../../component/singleSelect/SingleSelect";
import JobSearch from "../../../assets/images/search-job.png";
import Image from "../../../../component/image/Image";
import { useSelector } from "react-redux";
import LinkedIn from "../../../../assets/images/linkedIn-white.png";
import FaceBook from "../../../../assets/images/facebook-white.png";
import FilterPageTwo from "../FilterPageTow";
import { clientIds } from "../../../../config/clients/clients";
import useClientConfig from "../../../../config/careers/clientConfig";

const OptionThreeJobFilter = (props: any) => {
    const location = useLocation();
    const routeParams = useParams();
    const jobsList = useSelector((state: any) => state.careers.allJobList);
    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const langLabels = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const searchLangLabels = langLabels?.searchSection?.[0];
    const {clientSiteSettings} = useClientConfig();
    const templateName = clientSiteSettings?.templateName;
  

    const { navigateToJob, navigateToJobAlerts, filter, checkListControl, tableControl, searchControlSubmit, setTableControl, removeSearchForm } = props;
    const submitSearch = () => {
        searchControlSubmit();
    };
    

    
    return (
        <>
        <div className="option3-job-search-box-parent">
            <div className={`job-search-box option3-job-search-box ${location.pathname === `/view/${routeParams?.id}` ? "filter-background1" : ""}`}>
                <div className="d-flex align-items-center d-flex-search-job">
                    {/* <i className="pi pi-search top-search fw-bolder pe-2"></i> */}
                    <h2 className="search-job mb-0">
                        {searchLangLabels?.searchJobs}
                    </h2>

                    {/* && jobsList?.data?.data?.jobs?.item?.length > 0  */}
                    {location.pathname !== `/view/${routeParams?.id}` && checkListControl ?
                        <div className="btn-clear-filter">
                            <Button onClick={() => removeSearchForm()} clasName="btn completion-btn-primary" icon={"pi pi-times custom-close-filter"} position="left" label={"Clear Filters"} />
                        </div>
                        :
                        ""
                    }

                </div>
                <div className="form-group search-bg-form-group position-relative common-before-icon search-icon">
                    {/* <Image src={JobSearch} clasName="filer-search-icon" /> */}
                    <i className="pi pi-search  fw-bolder filer-search-icon"></i>

                    <Input
                        className={`form-control active filter-in ${tableControl.searchText ? "filter-in-active" : ""}`}
                        type={"text"}
                        value={tableControl.searchText}
                        placeholder={clientSiteSettings?.templateName === "template_10" ? "Search by Job Title, Keywords.." : searchLangLabels?.searchPlaceholder+"..."}
                        name={searchLangLabels?.search}
                        onChange={(e: { target: { value: any; }; }) => {
                            setTableControl((prs: any) => {
                                return {
                                    ...prs,
                                    searchText: e.target.value
                                };
                            });
                        }
                        }
                    />
                </div>

                {filter.jobCategories &&  templateName !== "template_34"?
                    <div className={`cust-select-parent cust-select-category-parent cust-select-drop-category-parent ${tableControl.searchCat.length > 0 ? "location-border" : ""}`}>
                        <label>{searchLangLabels?.category} :</label>
                        {/* {catSelect()} */}
                        <Select isSearchable={true} className="joblist-multi-select" placeholder={searchLangLabels?.all} isMulti={true} onChange={(e: any) => {
                            setTableControl((prs: any) => {
                                return {
                                    ...prs,
                                    searchCat: e
                                };
                            });
                        }} value={tableControl.searchCat} options={filter.jobCategories} />
                        {/* <i className="pi pi-angle-down"></i> */}
                    </div>
                    :
                    ""
                }

                {/* <div>
                    <CategorySelect />
                </div> */}

                {filter.jobTypes &&  templateName !== "template_34" ?
                    <div className={`cust-select-parent cust-select-category-parent cust-select-drop-job-types  ${tableControl.searchJob.length > 0 ? "location-border" : ""}`}>
                        <label>{searchLangLabels?.jobTypes} :</label>
                        <Select isSearchable={true} className={"joblist-multi-select job-select"} placeholder={searchLangLabels?.all} isMulti={true} onChange={(e: any) => {
                            setTableControl((prs: any) => {
                                return {
                                    ...prs,
                                    searchJob: e
                                };
                            });
                        }} value={tableControl.searchJob} options={filter.jobTypes} />
                        {/* {joTypeSelect()} */}

                        {/* <select className="form-control job-type" value={tableControl.searchJob}
                                                onChange={(e) => setTableControl((prs) => {
                                                    return {
                                                        ...prs,
                                                        searchJob: e.target.value
                                                    };
                                                })}
                                            >
                                                <>
                                                    <option key={""} value={""}>{"All"}</option>
                                                    {filterListData.jobTypes && (filterListData.jobTypes as any[]).map((ress: any) => {
                                                        return (
                                                            <option key={ress.jobTypeId} value={ress.jobTypeId}>
                                                                {ress.typeName}
                                                            </option>
                                                        );
                                                    })}
                                                </>
                                            </select> */}
                        {/* <i className="pi pi-angle-down"></i> */}
                    </div>
                    :
                    ""
                }
                {
                    filter.jobLocations &&  templateName !== "template_34" ?
                        <div className={`cust-select-parent cust-select-category-parent cust-select-drop-locations ${tableControl.searchLocation.length > 0 ? "location-border" : ""}`}>
                            <label>{searchLangLabels?.locations} :</label>
                            {/* {locationSelect()} */}
                            <Select isSearchable={true} className="joblist-multi-select location-select" placeholder={searchLangLabels?.all} isMulti={true}
                                onChange={(e: any) => {
                                    setTableControl((prs: any) => {
                                        return {
                                            ...prs,
                                            searchLocation: e
                                        };
                                    });
                                }} value={tableControl.searchLocation} options={filter.jobLocations} />
                            {/* <Select
                                className="joblist-multi-select"
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                options={filterListData.jobLocations}
                                onChange={(e: any) => setTableControl((prs: any) => {
                                    return {
                                        ...prs,
                                        searchLocation: e
                                    };
                                })}
                                isMulti
                            /> */}

                            {/* <i className="pi pi-angle-down"></i> */}
                        </div>
                        :
                        ""
                }


                <div className="btn-section">
                    <Button
                        clasName="btn-new btn-primary-new"
                        label={searchLangLabels?.search}
                        position="left"
                        icon="pi pi-search"
                        onClick={() => submitSearch()}
                    />
                </div>
            </div>
        </div>
            
        </>
    );
};

export default OptionThreeJobFilter;